module.exports = __webpack_public_path__ + "img/1.f19bcc1e.png";